document.addEventListener('DOMContentLoaded', function () {

  const searchInput = document.getElementById('case-studies-search');
  const industryFilter = document.getElementById('industry-filter');
  const tagFilter = document.getElementById('tag-filter');
  const sortFilter = document.getElementById('sort-filter');
  const clearButton = document.getElementById('clear-filters');
  const grid = document.getElementById('case-studies-grid');
  const noResults = document.getElementById('no-results');
  const industryLabel = document.getElementById('results-industry-name');
  const paginationContainer = document.getElementById('case-studies-pagination-container');

  if (!grid) return;

  // /case-studies/ (the hub) marks itself with data-case-studies-hub. There the
  // results grid only appears once a filter is in use, the industry list keeps
  // live counts, and its links carry the filters into the industry pages.
  const hub = document.querySelector('[data-case-studies-hub]');
  const hubResults = hub ? document.getElementById('case-studies-results') : null;
  const hubIndustriesTitle = hub ? document.getElementById('case-studies-industries-title') : null;
  const hubStatus = hub ? document.getElementById('case-studies-status') : null;
  const hubTiles = hub ? Array.from(hub.querySelectorAll('.designs-list__item[data-industry-id]')) : [];
  const hubOptions = hub && industryFilter ? Array.from(industryFilter.querySelectorAll('option[data-industry-id]')) : [];
  const hubAllOption = hub && industryFilter ? industryFilter.querySelector('option[data-all-industries]') : null;
  const hubQuickLinks = hub ? Array.from(hub.querySelectorAll('[data-quick-tag]')) : [];
  const DEFAULT_SORT = 'date-desc';
  // `industry` is a WordPress query var of its own: /case-studies/?industry=x
  // is canonicalised to the designs page for x, and an unknown slug is a 404.
  // The hub therefore keeps its industry filter under a name WordPress ignores.
  const HUB_INDUSTRY_PARAM = 'case_industry';

  let currentFilters = {
    search: searchInput ? searchInput.value : '',
    industry: industryFilter ? industryFilter.value : '',
    tag: tagFilter ? tagFilter.value : '',
    sort: sortFilter ? sortFilter.value : DEFAULT_SORT,
    paged: paginationContainer && paginationContainer.dataset.currentPage ? parseInt(paginationContainer.dataset.currentPage, 10) || 1 : 1
  };

  // Only the newest request may paint: typing or picking quickly must not let
  // a slow earlier response overwrite a newer one.
  let inflight = null;

  // Counts depend on tag + search only, so they are asked for only when one of
  // those changed. appliedCounts is what the page currently shows (null = the
  // unfiltered numbers rendered into the page); appliedCountsKey is the
  // tag + search they belong to.
  const HUB_BASE_KEY = '\u0001';
  let appliedCounts = null;
  let appliedCountsKey = HUB_BASE_KEY;

  if (searchInput) searchInput.addEventListener('input', debounce(handleSearch, 300));
  if (industryFilter) industryFilter.addEventListener('change', handleIndustryFilter);
  if (tagFilter) tagFilter.addEventListener('change', handleTagFilter);
  if (sortFilter) sortFilter.addEventListener('change', handleSortFilter);
  if (clearButton) clearButton.addEventListener('click', clearAllFilters);
  if (paginationContainer) paginationContainer.addEventListener('click', handlePaginationClick);

  function handleSearch(e) {
    const search = e.target.value.trim();
    // A trailing space (or a space-only box) changes nothing the server sees.
    if (search === currentFilters.search) return;
    currentFilters.search = search;
    currentFilters.paged = 1;
    fetchCaseStudies();
  }

  function handleIndustryFilter(e) {
    // Keep every filter available when this industry/tag combination is empty.
    currentFilters.industry = e.target.value;
    currentFilters.paged = 1;
    updateIndustryLabel();
    fetchCaseStudies();
  }

  function handleTagFilter(e) {
    currentFilters.tag = e.target.value;
    currentFilters.paged = 1;
    fetchCaseStudies();
  }

  function handleSortFilter(e) {
    currentFilters.sort = e.target.value;
    currentFilters.paged = 1;
    fetchCaseStudies();
  }

  function clearAllFilters() {
    if (searchInput) searchInput.value = '';
    if (industryFilter) industryFilter.value = '';
    if (tagFilter) tagFilter.value = '';
    if (sortFilter) sortFilter.value = DEFAULT_SORT;
    currentFilters = {
      search: '',
      industry: '',
      tag: '',
      sort: DEFAULT_SORT,
      paged: 1
    };
    updateIndustryLabel();
    fetchCaseStudies();
  }

  function handlePaginationClick(e) {
    const link = e.target.closest('a.page-numbers');
    if (!link) return;

    e.preventDefault();

    let pageNum = 1;
    try {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      pageNum = parseInt(url.searchParams.get('paged'), 10) || 1;
    } catch (err) {
      return;
    }

    currentFilters.paged = pageNum;
    fetchCaseStudies();

    const filtersBar = document.querySelector('.case-studies-filters');
    if (filtersBar) filtersBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function updateIndustryLabel() {
    if (!industryLabel || !industryFilter) return;
    const selectedOption = industryFilter.options[industryFilter.selectedIndex];
    // Hub options carry their live count in the text, so read the bare name.
    industryLabel.textContent = selectedOption ? (selectedOption.dataset.name || selectedOption.textContent).trim() : '';
  }

  // ---- Hub only -----------------------------------------------------------

  // Anything but the page's resting state shows results instead of just the
  // industry list. Sort counts: "A-Z" alone is a request to see the studies.
  function hubIsFiltered() {
    return !!(currentFilters.search || currentFilters.industry || currentFilters.tag || currentFilters.sort !== DEFAULT_SORT);
  }

  // The filters that travel with a click on an industry, and the ones kept in
  // the address bar. Industry is left out of the links (the click picks it).
  function hubQuery(includeIndustry) {
    const params = new URLSearchParams();
    if (currentFilters.search) params.set('search', currentFilters.search);
    if (includeIndustry && currentFilters.industry) params.set(HUB_INDUSTRY_PARAM, currentFilters.industry);
    if (currentFilters.tag) params.set('tag', currentFilters.tag);
    if (currentFilters.sort !== DEFAULT_SORT) params.set('sort', currentFilters.sort);
    return params.toString();
  }

  function hubSyncLinksAndUrl() {
    hubQuickLinks.forEach(function (link) {
      if (link.dataset.quickTag === currentFilters.tag) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });

    const carried = hubQuery(false);
    hubTiles.forEach(function (tile) {
      const link = tile.querySelector('a');
      if (!link) return;
      if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute('href');
      link.setAttribute('href', link.dataset.baseHref + (carried ? '?' + carried : ''));
    });

    try {
      const url = new URL(window.location.href);
      ['search', HUB_INDUSTRY_PARAM, 'tag', 'sort'].forEach(function (key) { url.searchParams.delete(key); });
      new URLSearchParams(hubQuery(true)).forEach(function (value, key) { url.searchParams.set(key, value); });
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (err) { /* sandboxed frames can refuse; the page still works */ }
  }

  function hubShowResults(show) {
    if (hubResults) hubResults.hidden = !show;
    if (hubIndustriesTitle) hubIndustriesTitle.hidden = !show;
  }

  // Back to the resting state: drop the old grid so the next reveal can't
  // flash the previous results.
  function hubResetResults() {
    hubShowResults(false);
    grid.innerHTML = '';
    if (paginationContainer) {
      paginationContainer.innerHTML = '';
      paginationContainer.dataset.currentPage = '1';
    }
    if (hubStatus) hubStatus.textContent = '';
  }

  function hubSetCount(el, n) {
    const countEl = el.querySelector('.designs-list__count');
    if (countEl) countEl.textContent = '(' + n.toLocaleString('en-US') + ')';
    el.classList.toggle('is-empty', n === 0);
    const link = el.querySelector('a');
    if (link) {
      if (n === 0) {
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '-1');
      } else {
        link.removeAttribute('aria-disabled');
        link.removeAttribute('tabindex');
      }
    }
  }

  // counts: {all, industries: {termId: n}} for the current tag + search, or
  // null for the resting state, which is rendered into the page (data-count).
  function hubApplyCounts(counts, key) {
    appliedCounts = counts;
    appliedCountsKey = key;
    hubTiles.forEach(function (tile) {
      const n = counts ? (counts.industries[tile.dataset.industryId] || 0) : parseInt(tile.dataset.count, 10) || 0;
      hubSetCount(tile, n);
      tile.classList.toggle('is-active', !!currentFilters.industry && tile.dataset.industrySlug === currentFilters.industry);
    });

    hubOptions.forEach(function (option) {
      const n = counts ? (counts.industries[option.dataset.industryId] || 0) : parseInt(option.dataset.count, 10) || 0;
      option.textContent = option.dataset.name + ' (' + n.toLocaleString('en-US') + ')';
      // Never disable the option that is currently picked.
      option.disabled = n === 0 && option.value !== currentFilters.industry;
    });

    if (hubAllOption) {
      const all = counts ? counts.all : parseInt(hubAllOption.dataset.count, 10) || 0;
      hubAllOption.textContent = hubAllOption.dataset.name + ' (' + all.toLocaleString('en-US') + ')';
    }
  }

  // ---- Fetch ----------------------------------------------------------------

  // isRetry: already retried once with a fresh nonce, so don't loop.
  function fetchCaseStudies(isRetry) {
    if (!grid) return;

    if (hub) {
      hubSyncLinksAndUrl();
      if (!hubIsFiltered()) {
        // Resting state: everything it needs was rendered into the page, so
        // there is nothing to ask the server for.
        if (inflight) inflight.abort();
        inflight = null;
        grid.classList.remove('loading');
        hubResetResults();
        hubApplyCounts(null, HUB_BASE_KEY);
        return;
      }
    }

    // Everything but tag + search can change without the counts changing.
    const countsKey = currentFilters.tag + '\u0001' + currentFilters.search;
    const needCounts = !!hub && countsKey !== appliedCountsKey;
    // The marker on the picked industry and the dropdown's disabled options
    // follow the industry filter, so refresh them with the counts already shown.
    if (hub && !needCounts) hubApplyCounts(appliedCounts, appliedCountsKey);

    grid.classList.add('loading');
    const data = new FormData();
    data.append('action', 'pcm_load_case_studies');
    data.append('search', currentFilters.search);
    data.append('industry', currentFilters.industry);
    data.append('tag', currentFilters.tag);
    data.append('sort', currentFilters.sort);
    data.append('paged', currentFilters.paged);
    data.append('nonce', pcm_ajax.nonce);
    // Ride the industry counts along with the grid: one request, not two.
    if (needCounts) data.append('counts', '1');

    if (inflight) inflight.abort();
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    inflight = controller;

    fetch(pcm_ajax.ajax_url, {
      method: 'POST',
      body: data,
      signal: controller ? controller.signal : undefined
    })
      .then(response => response.json())
      .then(result => {
        // A newer request started while this one was finishing: let it paint.
        if (controller && inflight !== controller) return;

        // The page's nonce can expire before the cached page does: get a live
        // one and retry once, rather than showing an empty "no results" grid.
        if (!result.success && !isRetry && result.data && result.data.message === 'Invalid nonce' && window.pcmFetchFreshNonce) {
          return window.pcmFetchFreshNonce('case_studies_nonce').then(nonce => {
            pcm_ajax.nonce = nonce;
            fetchCaseStudies(true);
          });
        }

        if (result.success) {
          grid.innerHTML = result.data.html;
          if (paginationContainer) {
            paginationContainer.innerHTML = result.data.pagination || '';
            paginationContainer.dataset.currentPage = String(currentFilters.paged);
          }
          updateResultsSummary(result.data);
          if (hub && result.data.counts) hubApplyCounts(result.data.counts, countsKey);
        } else {
          grid.innerHTML = '';
          if (paginationContainer) paginationContainer.innerHTML = '';
          updateResultsSummary({ html: '', total: 0 });
        }
        // Only now, with an answer in hand: revealing the block earlier showed
        // "0 of 0" and an invisible grid for the length of the request.
        if (hub) hubShowResults(true);
        grid.classList.remove('loading');
      })
      .catch(err => {
        // Superseded by a newer request, which owns the loading state now.
        if (err && err.name === 'AbortError') return;
        grid.classList.remove('loading');
      });
  }

  function updateResultsSummary(data) {
    if (!grid) return;
    const resultsCountEl = document.getElementById('results-count');
    const totalCountEl = document.getElementById('total-count');
    const currentCount = grid.querySelectorAll('li').length;
    if (resultsCountEl) resultsCountEl.textContent = currentCount;
    if (totalCountEl) totalCountEl.textContent = data.total || 0;
    if (hubStatus) hubStatus.textContent = (data.total || 0) + (data.total === 1 ? ' case study found' : ' case studies found');
    if (currentCount === 0) {
      grid.style.display = 'none';
      if (noResults) noResults.style.display = '';
    } else {
      grid.style.display = '';
      if (noResults) noResults.style.display = 'none';
    }
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Allow case study card tag badges to drive the tag filter without navigating away
  window.filterByTag = function (tagSlug) {
    if (tagFilter) tagFilter.value = tagSlug || '';
    currentFilters.tag = tagSlug || '';
    currentFilters.paged = 1;
    fetchCaseStudies();
  };

  window.clearTagFilter = function () {
    window.filterByTag('');
  };

  // Restore filters from a shared or bookmarked link.
  const urlParams = new URLSearchParams(window.location.search);
  const urlTag = urlParams.get('tag');
  const urlSort = urlParams.get('sort');
  const urlSearch = urlParams.get('search');
  const urlIndustry = urlParams.get(hub ? HUB_INDUSTRY_PARAM : 'industry');
  let needsFetch = false;

  if (urlTag && tagFilter) {
    tagFilter.value = urlTag;
    currentFilters.tag = urlTag;
    needsFetch = true;
  }

  if (urlSort && sortFilter) {
    sortFilter.value = urlSort;
    currentFilters.sort = urlSort;
    needsFetch = true;
  }

  if (urlSearch && urlSearch.trim() && searchInput) {
    searchInput.value = urlSearch;
    currentFilters.search = urlSearch.trim();
    needsFetch = true;
  }

  if (urlIndustry && industryFilter) {
    industryFilter.value = urlIndustry;
    currentFilters.industry = urlIndustry;
    updateIndustryLabel();
    needsFetch = true;
  }

  // A link can name a tag, sort or industry that no longer exists. Assigning an
  // unknown value to a select leaves it with nothing selected (it shows blank),
  // so put it back on its first option and take the select's word for it,
  // rather than filtering by a value the visitor can't see or change.
  if (hub) {
    [tagFilter, sortFilter, industryFilter].forEach(function (select) {
      if (select && select.selectedIndex === -1) select.selectedIndex = 0;
    });
    if (tagFilter) currentFilters.tag = tagFilter.value;
    if (sortFilter) currentFilters.sort = sortFilter.value || DEFAULT_SORT;
    if (industryFilter) {
      currentFilters.industry = industryFilter.value;
      updateIndustryLabel();
    }
    needsFetch = hubIsFiltered();

    // An industry with no matches is greyed out; keep a screen reader's link
    // (which ignores pointer-events) from taking it to an empty page.
    hub.addEventListener('click', function (e) {
      const link = e.target.closest('a[aria-disabled="true"]');
      if (link) e.preventDefault();
    });

    // The quick links above the bar (Videos, Daily Mailers...) are the tag
    // filter in one click; their hrefs (?tag=...) only matter without JS.
    hubQuickLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        if (!tagFilter) return;
        tagFilter.value = link.dataset.quickTag;
        tagFilter.dispatchEvent(new Event('change'));
      });
    });

    // Drop params we manage that turned out to be unusable (?tag=nope).
    if (window.location.search) hubSyncLinksAndUrl();
  }

  if (needsFetch) fetchCaseStudies();
});
